import { getServerNow } from "../services/publicAuthConfigService";

const PERSIAN_DIGITS = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

const LIVE_TAG = "پخش زنده";

export const toPersianDigits = (value) =>
  String(value).replace(/\d/g, (digit) => PERSIAN_DIGITS[Number(digit)]);

const normalizeTimestamp = (value, allowDateStrings = true) => {
  if (value instanceof Date) {
    const timestamp = value.getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  if (value === null || value === undefined || value === "") return null;

  if (typeof value === "number" || typeof value === "string") {
    const raw = String(value).trim();

    if (/^\d{4}$/.test(raw)) return null;
    if (/^\d{10}$/.test(raw)) return Number(raw) * 1000;
    if (/^\d{13}$/.test(raw)) return Number(raw);

    if (allowDateStrings && Number.isNaN(Number(raw))) {
      const timestamp = new Date(raw).getTime();
      return Number.isNaN(timestamp) ? null : timestamp;
    }
  }

  return null;
};

export const isTimestampLikeYear = (value) => normalizeTimestamp(value, false) !== null;

export const getLiveStartTimestamp = (content = {}) => {
  const candidates = [
    content?.liveInfo?.liveStartDate,
    content?.liveStartDate,
    content?.startDate,
    content?.year,
  ];

  for (const candidate of candidates) {
    const timestamp = normalizeTimestamp(candidate);
    if (timestamp !== null) return timestamp;
  }

  return null;
};

export const getFutureLiveStartTimestamp = (content = {}, now = getServerNow()) => {
  const timestamp = getLiveStartTimestamp(content);
  return timestamp && timestamp > now ? timestamp : null;
};

export const getDisplayYear = (year) => (isTimestampLikeYear(year) ? null : year);

export const isLiveContent = (content = {}) => {
  const isLive = content?.isLive === true || content?.isLive === 1 || content?.isLive === "1";
  const kind = content?.contentType?.kind || content?.kind;
  const tags = Array.isArray(content?.tags) ? content.tags : [];

  return (
    isLive ||
    kind === "live" ||
    tags.includes(LIVE_TAG) ||
    Boolean(content?.liveInfo?.liveStartDate) ||
    Boolean(content?.liveStartDate) ||
    Boolean(content?.startDate) ||
    Boolean(content?.streamKey) ||
    Boolean(content?.liveEventId)
  );
};

export const getCountdownParts = (diff) => {
  const safeDiff = Math.max(0, diff);

  return {
    days: Math.floor(safeDiff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((safeDiff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((safeDiff / 1000 / 60) % 60),
    seconds: Math.floor((safeDiff / 1000) % 60),
  };
};
